import { useAuthentication } from '@/hooks/useAuthentication';
import { useEffect } from 'react';
import Smartlook from 'smartlook-client';

function SmartlookSH() {
  const result = useAuthentication();

  useEffect(() => {
    const isProd = import.meta.env.VITE_API_URL === 'https://cms.app.edwinpeople.co.uk';

    if (!isProd || Smartlook.initialized()) {
      return;
    }

    console.info('Smartlook init');
    Smartlook.init('0f3efb78ed2c3cbde86c8574da6ad27705eaf108');
  }, []);

  useEffect(() => {
    if (!Smartlook.initialized()) {
      console.info(`Smartlook can't identify with uninitialized client`);
      return;
    }

    const user = result?.authentication?.user;
    const school = result?.schoolContext;

    if (!user?.id) {
      return;
    }

    Smartlook.identify(`user_${user?.email}`, {
      user_id: user?.id?.toString(),
      user_name: user?.forename + ' ' + user?.surname || '-',
      school_id: school?.documentId || '-',
      school_name: school?.name || '-',
      role: user?.profile || '-',
    });
  }, [result?.authentication?.user, result?.schoolContext]);

  return <></>;
}

export default SmartlookSH;
